import { Injectable } from '@angular/core';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { isNil } from '@web/utils';
import { Observable, of } from 'rxjs';
import { AdminProductQuantityHistoryReasonType } from '../enums/admin-product-quantity-history-reason-type';

@Injectable({
  providedIn: 'root',
})
export class AdminProductQuantityHistoryReasonTypeProviderService {
  /* prettier-ignore */
  private readonly entries = new Map<AdminProductQuantityHistoryReasonType, string>([
    [AdminProductQuantityHistoryReasonType.NewProduct, 'Dodanie produktu, początkowy stan'],
    [AdminProductQuantityHistoryReasonType.ByNewOrder, 'Nowe zamówienie'],
    [AdminProductQuantityHistoryReasonType.ByAddToOrderShipment, 'Dodanie do przesyłki'],
    [AdminProductQuantityHistoryReasonType.ByRemoveFromOrderShipment, 'Usunięcie z przesyłki'],
    [AdminProductQuantityHistoryReasonType.ByCancelOrder, 'Anulowanie zamówienia'],
    [AdminProductQuantityHistoryReasonType.ByRefundOrder, 'Zwrot zamówienia'],
    [AdminProductQuantityHistoryReasonType.Manual, 'Zmiana ręczna'],
  ]);

  public labelFor(type: AdminProductQuantityHistoryReasonType): Observable<string> {
    const entry = this.entries.get(type);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${type}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<
    SelectItem<AdminProductQuantityHistoryReasonType>[]
  > {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem(label, type),
      ),
    );
  }
}
